define(["./gatewayModule",
        "json!./gateway.json"],
    function (gatewayModule, gateway) {
        "use strict";

        gatewayModule.service("gatewayService", ["$http", function ($http) {
            return {
                findConfigurations: findConfigurations,
                findPermissionGroups: findPermissionGroups,
                saveConfiguration: saveConfiguration,
                removeConfiguration: removeConfiguration
            };

            function findConfigurations() {
                return $http.get(servicePath("configurations")).then(getData);
            }

            function findPermissionGroups(){
                return $http.get(servicePath("findAllPermissionGroups")).then(getData);
            }

            function saveConfiguration(configuration) {
                return $http.post(servicePath("save"), configuration).then(getData);
            }

            function removeConfiguration(configuration) {
                return $http.post(servicePath("remove"), configuration.id).then(getData);
            }


            function servicePath(serviceId) {
                return gateway.baseUrl + gateway.services[serviceId];
            }

            function getData(response) {
                return response.data;
            }
        }
        ]);
    });
